<template>
  <div>
    The definition of the shape is mandatory for the simulation of
              surface forces such as atmospheric drag and Sun radiation
              pressure.
              <br />
              It is also required when the power system needs to be simulated:
              in this case both solar panels and the propulsion system's axis
              can be defined.
              <br />
  </div>
</template>

<script>
export default {
  name: 'tooltipSpacecraftShape'
}
</script>
